// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_TournamentPage__8Z-NF{
    width: 80%;
    min-width: min-content;
    display: flex;
    flex-direction: column;
    justify-content: start;
    align-items: center;
    height: max-content;
    min-height: 100%;
    max-height: 100%;
    overflow-y: auto;   

    >:nth-child(1) {
        max-width: 1180px;
    }
}
.styles_ControlPanel__QlZdI{
    width: 100%;
    display: flex;
    justify-content: start;
}
.styles_ControlPanel__QlZdI > *{
    margin-left: 30px;
}
.styles_selectButton__dABpl{
    margin-top: 30px;
    display: flex;
    flex-direction: row;
    gap: 20px;
    padding-left: 30px;
}
.styles_selectButton__dABpl *{
    border: 1px solid black;
    padding: 5px;
}
.styles_loading__qQXoN {
    z-index: 1;
    position: absolute;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: rgba(206, 206, 206, 0.486);
}
.styles_Content__kSQ1C {
    background-color: white;
    padding-bottom: 20px;
}

@media (max-width: 768px) {
    .styles_Content__kSQ1C {
        >:nth-child(1) >div >div >div {
            width: 100vw;
            display: flex;
            justify-content: center;
            overflow-x: scroll;
            >button {
                width: max-content;
                min-width: max-content;
                font-size: 12px;
                padding: 8px 5px;
            }

        }
        
    }
}
`, "",{"version":3,"sources":["webpack://./src/pages/TournamentsPageN/styles.module.css"],"names":[],"mappings":"AAAA;IACI,UAAU;IACV,sBAAsB;IACtB,aAAa;IACb,sBAAsB;IACtB,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;;IAEhB;QACI,iBAAiB;IACrB;AACJ;AACA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;AAC1B;AACA;IACI,iBAAiB;AACrB;AACA;IACI,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;AACtB;AACA;IACI,uBAAuB;IACvB,YAAY;AAChB;AACA;IACI,UAAU;IACV,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,4CAA4C;AAChD;AACA;IACI,uBAAuB;IACvB,oBAAoB;AACxB;;AAEA;IACI;QACI;YACI,YAAY;YACZ,aAAa;YACb,uBAAuB;YACvB,kBAAkB;YAClB;gBACI,kBAAkB;gBAClB,sBAAsB;gBACtB,eAAe;gBACf,gBAAgB;YACpB;;QAEJ;;IAEJ;AACJ","sourcesContent":[".TournamentPage{\n    width: 80%;\n    min-width: min-content;\n    display: flex;\n    flex-direction: column;\n    justify-content: start;\n    align-items: center;\n    height: max-content;\n    min-height: 100%;\n    max-height: 100%;\n    overflow-y: auto;   \n\n    >:nth-child(1) {\n        max-width: 1180px;\n    }\n}\n.ControlPanel{\n    width: 100%;\n    display: flex;\n    justify-content: start;\n}\n.ControlPanel > *{\n    margin-left: 30px;\n}\n.selectButton{\n    margin-top: 30px;\n    display: flex;\n    flex-direction: row;\n    gap: 20px;\n    padding-left: 30px;\n}\n.selectButton *{\n    border: 1px solid black;\n    padding: 5px;\n}\n.loading {\n    z-index: 1;\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    background-color: rgba(206, 206, 206, 0.486);\n}\n.Content {\n    background-color: white;\n    padding-bottom: 20px;\n}\n\n@media (max-width: 768px) {\n    .Content {\n        >:nth-child(1) >div >div >div {\n            width: 100vw;\n            display: flex;\n            justify-content: center;\n            overflow-x: scroll;\n            >button {\n                width: max-content;\n                min-width: max-content;\n                font-size: 12px;\n                padding: 8px 5px;\n            }\n\n        }\n        \n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"TournamentPage": `styles_TournamentPage__8Z-NF`,
	"ControlPanel": `styles_ControlPanel__QlZdI`,
	"selectButton": `styles_selectButton__dABpl`,
	"loading": `styles_loading__qQXoN`,
	"Content": `styles_Content__kSQ1C`
};
export default ___CSS_LOADER_EXPORT___;
